var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVrResqueLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300.24 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.9;isolation:isolate;fill:url(#radial-gradient);}.cls-2{fill:#f66;}.cls-3{fill:#1d1d1b;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -278.38,
    cy: 143.22,
    r: 1.14,
    gradientTransform: "matrix(-52.89, 14.32, 14.2, 52.44, -16603.44, -3312.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f66",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f66",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-5",
    className: "cls-1",
    d: "M153.47,250.59l-9.35-22.3c6.09-2.43,10.14-7.52,10.14-14.75,0-10.24-7.82-16-18.68-16H115.85a1.38,1.38,0,0,0-1.32,1l-15,51.78a1.74,1.74,0,0,0,1.19,2.16,1.61,1.61,0,0,0,.49.07h51a1.39,1.39,0,0,0,1.27-1.91Z",
    transform: "translate(-65.26 -197.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-4",
    className: "cls-2",
    d: "M96,251.51l15.13-52.23a1.38,1.38,0,0,0-.94-1.71,1.73,1.73,0,0,0-.38,0l-43.14,0a1.38,1.38,0,0,0-1.38,1.37,1.42,1.42,0,0,0,.08.45l17.72,52.25a1.39,1.39,0,0,0,1.31.93H94.64A1.4,1.4,0,0,0,96,251.51Z",
    transform: "translate(-65.26 -197.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.26,231.69h-1.63v16H177.4V208.73h15.91c8.34,0,13.6,4.82,13.6,11.48,0,5.94-4.2,10.36-10.92,11.31l11.6,16.13h-9.24Zm-1.63-5.88h7.45c3.64,0,5.71-1.9,5.71-4.87s-2.07-4.93-5.71-4.93h-7.45Z",
    transform: "translate(-65.26 -197.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.67,241.49c3.64,0,5.48-1.29,6.77-3.64l6.33,4.2c-2.3,3.36-6.1,6.33-13.33,6.33-9.57,0-15.79-6.66-15.79-15.46a15.3,15.3,0,0,1,15.23-15.45,14.79,14.79,0,0,1,15.18,14.84,22.87,22.87,0,0,1-.17,3.13H216.77A7.68,7.68,0,0,0,224.67,241.49Zm6.6-11.48c-.78-3.86-3.36-6.27-7.16-6.27S217.5,226,216.66,230Z",
    transform: "translate(-65.26 -197.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M241.13,240.6l7-2.69c.78,2.57,2.91,4.09,6.22,4.09,2.46,0,3.92-1,3.92-2.69,0-5.15-15.74-2.69-15.74-12.83,0-5.6,4.59-9,11.76-9,5.88,0,10.14,2.41,11.37,6.49l-7,2.69a4.39,4.39,0,0,0-4.48-3c-2.24,0-3.47.89-3.47,2.41,0,4.76,15.79,1.9,15.79,12.76,0,5.94-4.87,9.58-12.43,9.58C247.51,248.38,242.81,245.69,241.13,240.6Z",
    transform: "translate(-65.26 -197.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.47,233A15.2,15.2,0,0,1,285,217.47c8,0,12.94,5.26,14.23,9.69l-7.39,2.91a6.66,6.66,0,0,0-6.67-5.21c-4.14,0-7.39,3.14-7.39,8.06s3.25,8.07,7.39,8.07a6.8,6.8,0,0,0,6.83-5.16l7.4,3c-1.29,4.32-6.22,9.58-14.4,9.58A15.18,15.18,0,0,1,269.47,233Z",
    transform: "translate(-65.26 -197.5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M330.67,218.14v29.51h-7.78v-2.8a11.93,11.93,0,0,1-8.62,3.53c-7.51,0-11.43-5.15-11.43-11.87V218.14h8.29v17.3a5.63,5.63,0,0,0,11.25.17V218.14Z",
    transform: "translate(-65.26 -197.5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.11,241.49c3.64,0,5.49-1.29,6.78-3.64l6.33,4.2c-2.3,3.36-6.11,6.33-13.33,6.33-9.58,0-15.79-6.66-15.79-15.46a15.29,15.29,0,0,1,15.23-15.45,14.78,14.78,0,0,1,15.17,14.84,23.16,23.16,0,0,1-.16,3.13H343.22A7.67,7.67,0,0,0,351.11,241.49ZM357.72,230c-.78-3.86-3.36-6.27-7.17-6.27S343.94,226,343.1,230Z",
    transform: "translate(-65.26 -197.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrResqueLogo);
export default __webpack_public_path__ + "static/media/vr-resque-logo.91794dabe5fe9e2c47f4d65812f4a5d2.svg";
export { ForwardRef as ReactComponent };